const inventoryHistories = {
  apiClient: null,
  path: '/franchises/inventory-histories',

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async getByBranch(id, page) {
    try {
      const response = await this.apiClient.get(`${this.path}/branch/${id}?page=${page ? page : 1}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default inventoryHistories;
